import React from "react";
import {
  Card,
  CardContent,
  TextField,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { useWatch, useFormState } from "react-hook-form";

const PEST_OPTIONS = ["Roaches", "Mosq", "Rodents", "Flies", "Ants", "Others"];

export default function FindingsCard({
  control,
  register,
  index,
  removeFinding,
  readOnly = false,
}) {
  const pestsObj = useWatch({ control, name: `findingsAreas.${index}.pests` }) || {};

  const { errors } = useFormState({ control });
  const rowErrors = errors?.findingsAreas?.[index] || {};

  const totalCount = PEST_OPTIONS.reduce((sum, key) => {
    const n = Number(pestsObj?.[key] ?? 0);
    return sum + (isNaN(n) ? 0 : n);
  }, 0);

  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
          SPECIFY AREA/S
        </Typography>

        <TextField
          label="Location"
          fullWidth
          size="small"
          sx={{ mb: 2 }}
          disabled={readOnly}
          InputProps={{ readOnly }}
          {...register(`findingsAreas.${index}.location`, {
            required: "Location is required",
          })}
          error={!!rowErrors?.location}
          helperText={rowErrors?.location?.message || ""}
        />

        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mb: 1.5 }}>
          {PEST_OPTIONS.map((pest) => (
            <TextField
              key={pest}
              label={pest}
              type="number"
              size="small"
              sx={{ width: 120, minWidth: 100 }}
              defaultValue={0}
              inputProps={{
                min: 0,
                readOnly,
              }}
              disabled={readOnly}
              {...register(`findingsAreas.${index}.pests.${pest}`, {
                valueAsNumber: true,
              })}
            />
          ))}
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            mb: 0.5,
            color: rowErrors?.pests ? "error.main" : "inherit",
          }}
        >
          Total Pest Count: {totalCount}
        </Typography>

        {rowErrors?.pests && (
          <Typography variant="caption" color="error">
            {rowErrors?.pests?.message}
          </Typography>
        )}

        {!readOnly && removeFinding && (
          <Box textAlign="right">
            <Button color="error" size="small" onClick={() => removeFinding(index)}>
              Remove Area
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}